import { Box, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import BlurredProgressiveImage from "./BlurredProgressiveImage";
import { getProjectUrl } from "../config/portfolioProjects";

const cardStyle = {
  width: {
    xs: "72%",
    sm: "28%",
    md: "28%",
    lg: "28%",
    xl: "28%",
  },
  filter: "grayscale(1)",
  "&:hover": {
    width: {
      xs: "75%",
      sm: "30%",
      md: "30%",
      lg: "30%",
      xl: "30%",
    },
    filter: "grayscale(0)",
  },
  transition: "width 1s ease, filter .6s ease",
};

const PortfolioCard = ({ project, onOpen, scrollToTopOnLoad = false }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(getProjectUrl(project.slug));
    if (onOpen) {
      onOpen();
    }
  };

  return (
    <Box sx={cardStyle} onClick={handleClick}>
      <Typography
        sx={{ fontSize: { xs: 24, sm: 29, md: 34, lg: 36, xl: 38 } }}
        variant="h3"
      >
        {project.title}
      </Typography>
      <Box>
        <BlurredProgressiveImage
          src={project.thumbnail.src}
          placeholder={project.thumbnail.placeholder}
          alt={project.alt}
          width="100%"
          onLoad={scrollToTopOnLoad ? () => window.scrollTo(0, 0) : undefined}
        />
      </Box>
    </Box>
  );
};

export default PortfolioCard;
